<template>
  <v-flex xs12>
    <v-flex
      style="background-color:#292929; color: #eee;"
      class="px-3 py-1 mt-4 elevation-0 xs12"
    >
      <h3 class="font-weight-bold subtitle xs12 flex">Used in</h3>
    </v-flex>

    <v-data-table
      :headers="headers"
      :items="rows"
      :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
      :pagination.sync="pagination"
      no-data-text="This contact is not currently used."
      class="elevation-0"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.usage }}</td>
        <td>
          <router-link v-if="props.item.route" :to="props.item.route">
            {{ props.item.title }}
          </router-link>
          <span v-else>{{ props.item.title }}</span>
        </td>
        <td>{{ props.item.detail }}</td>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
export default {
  props: {
    usages: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      pagination: { rowsPerPage: 10 },
      headers: [
        { text: 'Used as', value: 'usage' },
        { text: 'Record', value: 'title' },
        { text: 'Details', value: 'detail' }
      ]
    }
  },
  computed: {
    rows () {
      const rows = []

      this.addArtworkRows(rows, this.usages.artworks_as_acquisition_source, 'Acquisition source')
      this.addArtworkRows(rows, this.usages.artworks_as_registrar, 'Registrar')

      const exhibitions = this.usages.exhibitions_as_institution || []
      exhibitions.forEach(exhibition => {
        rows.push({
          usage: 'Exhibition institution',
          title: exhibition.title || `Exhibition #${exhibition.id}`,
          detail: this.dateRange(exhibition.duration_start, exhibition.duration_end),
          route: { name: 'EditExhibition', params: { id: exhibition.id } }
        })
      })

      const photos = this.usages.artwork_photos_as_photographer || []
      photos.forEach(photo => {
        rows.push({
          usage: 'Artwork photographer',
          title: photo.title || photo.fname || `Photo #${photo.id}`,
          detail: photo.artwork_id ? `Artwork #${photo.artwork_id}` : '',
          route: photo.artwork_id
            ? { name: 'EditArtwork', params: { id: photo.artwork_id } }
            : null
        })
      })

      return rows
    }
  },
  methods: {
    addArtworkRows (rows, artworks, usage) {
      const artworkItems = artworks || []
      artworkItems.forEach(artwork => {
        rows.push({
          usage,
          title: artwork.title || `Artwork #${artwork.id}`,
          detail: artwork.accession_number || '',
          route: { name: 'EditArtwork', params: { id: artwork.id } }
        })
      })
    },
    dateRange (start, end) {
      if (start && end) return `${start} – ${end}`
      return start || end || ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contacts/ContactUsageTable.vue